function fullName(firstName, lastName) {
  return !firstName ? null : !lastName ? firstName : "".concat(firstName, " ").concat(lastName);
}
export function reviewerFullName(reviewer) {
  return fullName(reviewer.firstName, reviewer.lastName);
}